import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { CookieService } from 'ngx-cookie-service';
import {variableGlobal} from './../global.enum'
import {adjuntoCorreo,envioCorreo,evento} from "./../model/Indesad"
import { environment } from 'src/environments/environment';
 

@Injectable({
  providedIn: 'root'
})
export class IntranetNewService {

  constructor(
    private _http: HttpClient,
  ) { }


  async ObtieneMenuAccesoProcesadoAdmin(objeto:any)
  {

    const body =  
      {
        "token": variableGlobal.TOKEN,
        "objeto": objeto
      }

    
    return this._http.post(environment.RUTA_API + '/api/IntranetV2/ObtieneMenuAccesoProcesadoAdmin', body).toPromise();
  }

  async ObtenerConfiguracion()
  {

    const body =  
     {"estado": true, "TOKEN": variableGlobal.TOKEN, "mensaje": "", "resultado": null}
  


    return this._http.post(environment.RUTA_API + '/api/IntranetV2/ObtenerConfiguracion', body).toPromise();
  }

  async enviaCorreo(objeto:envioCorreo, origen)
  {
    const body =  
    {
      ...objeto,
      origen
    }
    

    return this._http.post(environment.RUTA_API + '/api/IntranetV2/enviaCorreo', body).toPromise();
  }

  async ObtenerGrupoUsuarios()
  {
    const body =  "";
    return this._http.post(environment.RUTA_API + '/api/IntranetV2/GetUserGroups', body).toPromise();
  }

  async GuardarConfiguracion(config: any) {
    const body = { estado: true, TOKEN: variableGlobal.TOKEN, mensaje: '', resultado: config };
    return this._http.post(environment.RUTA_API + '/api/IntranetV2/GuardarConfiguracion', body).toPromise();
  }

  async ReconexionSAP() {
    const body = { estado: true, TOKEN: variableGlobal.TOKEN, mensaje: '', resultado: null };
    return this._http.post(environment.RUTA_API + '/api/INDESAD/reconexionConSAP', body).toPromise();
  }

}
